import styled, { css } from 'styled-components';
import theme from '../../assets/styles/theme';

export const Tooltip = styled.div`
  & {
    position: relative;
  }
  display: inline-block;
`;
export const TooltipOverlay = styled.div`
  position: absolute;
  z-index: 100;
`;

export const TooltipWrapper = styled.div`
  display: block;
  position: relative;
  ${({ position }) => getPositionWrapper(position)}
`;

export const TooltipArrow = styled.div`
  z-index: 12;
  position: absolute;
  display: block;
  width: 10px;
  height: 8px;
  border-style: solid;
  border-color: transparent;
  transform-origin: center bottom;
  ${({ position }) => getArrow(position)};
  ${({ position }) => getPositionArrow(position)};
`;

export const TooltipMessage = styled.div`
  pointer-events: none;
  will-change: transform;
  min-width: 50px;
  width: max-content;
  width: -moz-max-content;
  white-space: pre-wrap;
  border-radius: ${theme.spacing['spacing-1']};
  padding: ${theme.spacing['spacing-3']} ${theme.spacing['spacing-4']};
  background-color: ${theme.colors.neutral.bg.inverted};
  color: ${theme.colors.neutral.text.inverted};
`;

export const ChildrenWrapper = styled.div``;

const getPositionArrow = (position) => {
  switch (position) {
    case 'top':
      return css`
        border-width: 6px 6px 0 6px;
        bottom: 0;
        left: calc(50% - 6px);
      `;
    case 'top-right':
      return css`
        bottom: 0;
        border-width: 6px 6px 0 6px;
        right: calc(0% + 6px);
      `;
    case 'top-left':
      return css`
        bottom: 0;
        border-width: 6px 6px 0 6px;
        left: calc(0% + 6px);
      `;
    case 'bottom':
      return css`
        border-width: 0px 6px 6px 6px;
        top: 0;
        left: calc(50% - 6px);
      `;
    case 'bottom-left':
      return css`
        border-width: 0px 6px 6px 6px;
        left: calc(0% + 6px);
        top: 0;
      `;
    case 'bottom-right':
      return css`
        border-width: 0px 6px 6px 6px;
        right: calc(0% + 6px);
        top: 0;
      `;
    case 'right':
      return css`
        border-width: 6px 6px 6px 0px;
        left: 0;
        top: calc(50% - 6px);
      `;
    case 'left':
      return css`
        border-width: 6px 0px 6px 6px;
        right: 0;
        top: calc(50% - 6px);
      `;
  }
};

const getPositionWrapper = (position) => {
  switch (position) {
    case 'top':
      return css`
        padding: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-3']} ${theme.spacing['spacing-0']};
        margin: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-2']} ${theme.spacing['spacing-0']};
      `;
    case 'top-left':
      return css`
        padding: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-3']} ${theme.spacing['spacing-0']};
        margin: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-2']} ${theme.spacing['spacing-0']};
      `;
    case 'top-right':
      return css`
        padding: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-3']} ${theme.spacing['spacing-0']};
        margin: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-2']};
      `;
    case 'bottom':
      return css`
        padding: ${theme.spacing['spacing-3']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
        margin: ${theme.spacing['spacing-2']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
      `;

    case 'bottom-left':
      return css`
        padding: ${theme.spacing['spacing-3']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
        margin: ${theme.spacing['spacing-2']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
      `;
    case 'bottom-right':
      return css`
        padding: ${theme.spacing['spacing-3']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
        margin: ${theme.spacing['spacing-2']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
      `;
    case 'right':
      return css`
        padding: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-3']};
        margin: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-2']};
      `;
    case 'left':
      return css`
        padding: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-3']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
        margin: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-2']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
      `;
  }
};

const getArrow = (position) => {
  let aux = position.indexOf('-');
  let positions;
  aux == -1 ? (positions = position) : (positions = position.slice(0, aux));
  return css`
    border-color: transparent;
    border-${positions}-color: ${theme.colors.neutral.bg.inverted}`;
};
